import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  GET_SINGLE_STORE_PRODUCT_DATA,
  GET_SINGLE_STORE_PRODUCT_DATA_ELASTIC,
  BASE_URL_FOR_ELASTIC_SEARCH,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  storeProductData: {},
  currentQueryKey: null,
  activeInitialRequestId: null,
  error: '',
};

const productRequests = new Map();

const getProductQueryKey = (data = {}) =>
  JSON.stringify([
    String(data.merchant_id ?? '').trim().toUpperCase(),
    String(data.orderMethod ?? '').trim().toLowerCase(),
    String(data.category_id ?? ''),
    Boolean(data.elastic),
  ]);

const getProductRequestKey = (data = {}, isElasticConnected) =>
  JSON.stringify([
    getProductQueryKey({ ...data, elastic: isElasticConnected }),
    Number(data.offset) || 0,
    Number(data.limit) || 0,
  ]);

// Generate pening , fulfilled and rejected action type
export const fetchSingleStoreProductData = createAsyncThunk(
  'storeProductData/fetchSingleStoreProductData',
  async (data, { getState }) => {
    const state = getState();
    const isElasticConnected =
      state?.allStatesData?.isElasticConnected === true;
    const endpoint = isElasticConnected
      ? GET_SINGLE_STORE_PRODUCT_DATA_ELASTIC
      : GET_SINGLE_STORE_PRODUCT_DATA;
    const baseUrl = isElasticConnected
      ? BASE_URL_FOR_ELASTIC_SEARCH
      : BASE_URL_SANDBOX;
    const requestKey = getProductRequestKey(data, isElasticConnected);
    let request = productRequests.get(requestKey);

    if (!request) {
      request = axios
        .post(baseUrl + endpoint, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.status === 200) {
            return response.data.result;
          }
          if (response.data.status === 404) {
            throw new Error('404_NOT_FOUND');
          }
          throw new Error(`Server error: ${response.data.status}`);
        })
        .catch((error) => {
          if (error.response?.data?.status === 404) {
            throw new Error('404_NOT_FOUND');
          }
          throw new Error(error.message);
        })
        .finally(() => {
          productRequests.delete(requestKey);
        });
      productRequests.set(requestKey, request);
    }

    return request;
  },
);

export const fetchSingleStoreProductDataOld = createAsyncThunk(
 
  'storeProductData/fetchSingleStoreProductData',
  async (data) => {
    
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + GET_SINGLE_STORE_PRODUCT_DATA,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );

      if (response.data.status === 200) {
        return response.data.result;
      } else throw new Error(`Server error`);
    } catch (error) {
      new Error(error.message);
    }
  },
);

const singleStoreProductDataSlice = createSlice({
  name: 'storeProductData',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchSingleStoreProductData.pending, (state, action) => {
      const offset = Number(action.meta.arg?.offset) || 0;
      const queryKey = getProductQueryKey(action.meta.arg);

      if (offset === 0) {
        state.loading = true;
        state.currentQueryKey = queryKey;
        state.activeInitialRequestId = action.meta.requestId;
        state.storeProductData = {};
        state.error = '';
      }
    });
    builder.addCase(fetchSingleStoreProductData.fulfilled, (state, action) => {
      const offset = Number(action.meta.arg?.offset) || 0;
      const queryKey = getProductQueryKey(action.meta.arg);
      if (state.currentQueryKey !== queryKey) return;

      if (offset === 0) {
        if (state.activeInitialRequestId !== action.meta.requestId) return;
        state.loading = false;
        state.storeProductData = action.payload;
        state.activeInitialRequestId = null;
        state.error = '';
        return;
      }

      const incomingCollections = Array.isArray(action.payload?.all_collection)
        ? action.payload.all_collection
        : [];
      state.storeProductData = {
        ...state.storeProductData,
        all_collection: [
          ...(state.storeProductData?.all_collection || []),
          ...incomingCollections,
        ],
        all_banners: action.payload?.all_banners || [],
        all_product: {
          ...(state.storeProductData?.all_product || {}),
          ...(action.payload?.all_product || {}),
        },
      };
      state.error = '';
    });
    builder.addCase(fetchSingleStoreProductData.rejected, (state, action) => {
      const offset = Number(action.meta.arg?.offset) || 0;
      const queryKey = getProductQueryKey(action.meta.arg);
      if (state.currentQueryKey !== queryKey) return;

      if (
        offset === 0 &&
        state.activeInitialRequestId === action.meta.requestId
      ) {
        state.loading = false;
        state.activeInitialRequestId = null;
        state.storeProductData = {};
        state.error = action.error.message;
      }
    });
  },
});

export default singleStoreProductDataSlice.reducer;
